export default class ProfileResponse {
    constructor (json) {
        this.json = json
    }

    getProperty (name) {
        return this.json[name]
    }

    toObj () {
        return this.json
    }
}

// {
//     "responseCode": "SUCCESS",
//     "accountNumber": 3026436,
//     "memberId": "3304925500",
//     "memberIdStatus": "ACT",
//     "firstName": "Dave",
//     "lastName": "Collins",
//     "middleName": "",
//     "emailAddress": "dave@innismaggiore.com",
//     "gender": "M",
//     "dateOfBirth": "1981-04-04",
//     "referralUrl": "",
//     "phoneNumber": [
//         {
//             "number": "3304925500",
//             "type": "M",
//             "category": "P"
//         }
//     ],
//     "address": [
//         {
//             "street1": "345 Poplar Ave",
//             "street2": "Line 2",
//             "city": "Canton",
//             "stateCode": "OH",
//             "zipCode": "44708",
//             "type": "P"
//         }
//     ],
//     "partSrcId": "true",
//     "memberAttributes": [],
//     "status": "ACT"
// }



// WEBPACK FOOTER //
// ./src/models/responses/ProfileResponse.js